import { render, staticRenderFns } from "./AccountHolderCardSettings.vue?vue&type=template&id=36fd6512"
import script from "./AccountHolderCardSettings.vue?vue&type=script&lang=ts"
export * from "./AccountHolderCardSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports